import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import routerList from './routerList';

function App() {

  return (
    <Router>
      <Routes>
        {routerList.map((item: any, index: number) => {
          return <Route key={index} {...item}/>
        })}
      </Routes>
    </Router>
  );
}

export default App;
